// extracted by mini-css-extract-plugin
export default {"app":"app_app__HViOs","content":"app_content__awj-J"};